export default {"src":"/_next/static/media/WhoWeAre_030A.69c6c6c1.JPG","height":704,"width":1920};